// Barrel export — re-exports everything for backward compatibility
// Existing imports from '@/services/api' continue to work via this file.

import { employeesApi, formatEmployeeTitles } from './employees';
import { teamsApi } from './teams';
import { payrollApi } from './payroll';
import { evaluationsApi } from './evaluations';
import { trainingApi } from './training';
import { leaveApi } from './leave';
import { organizationApi } from './organization';
import { transfersApi } from './transfers';
import { workflowApi } from './workflow';
import { authApi } from './auth';
import { reportsApi } from './reports';
import { adminApi } from './admin';
import { complianceApi } from './compliance';
import { onboardingChecklistApi } from './onboardingChecklist';
import { leaveRequestsApi } from './leaveRequests';
import { overtimeApi } from './overtime';
import { attendanceApi } from './attendance';
import { noticesApi } from './notices';
import { fetchMenuPermissions, getMenuPermission } from './menuPermissions';

// Base client and error class
export { api, API_BASE_URL, ApiError } from './client';

// All shared types and constants
export * from './types';

// Helper function
export { formatEmployeeTitles };

// Domain-specific service objects
export {
  employeesApi, teamsApi, payrollApi, evaluationsApi,
  trainingApi, leaveApi, organizationApi, transfersApi,
  workflowApi, authApi, reportsApi, adminApi, complianceApi,
  onboardingChecklistApi, leaveRequestsApi, overtimeApi, noticesApi,
  attendanceApi,
};

// Re-export types from onboardingChecklist for consumers
export type {
  OnboardingTemplate, OnboardingTask, OnboardingTaskStatus,
  EmployeeTasksResponse, OnboardingSummary, OnboardingEmployeeSummary,
} from './onboardingChecklist';

// MYB-276: Leave self-service types
export type { LeaveType, LeaveBalance, LeaveRequest, SubmitLeaveRequest, ReviewLeaveRequest } from './leaveRequests';

// MYB-364: Menu permissions
export { fetchMenuPermissions, getMenuPermission };
export type { MenuPermission, MenuPermissionMap, MenuPermissionsResponse } from './menuPermissions';

// MYB-277: Overtime import types
export type {
  OvertimeThresholds, OvertimePreview, OvertimePreviewRow,
  OvertimeImportResult, OvertimeWeeklyRow, OvertimeAlert,
  OvertimeMonthlyRow, OvertimeDailyRecord,
} from './overtime';

// Unified apiService object — backward compatibility shim
// NOTE: attendance, overtime, onboarding, leaveRequests are namespaced (not flat-spread)
// to avoid method name collisions (e.g. getRecords, getAuditLogs exist in multiple APIs).
export const apiService = {
  ...employeesApi,
  ...teamsApi,
  ...payrollApi,
  ...evaluationsApi,
  ...trainingApi,
  ...leaveApi,
  ...organizationApi,
  ...transfersApi,
  ...workflowApi,
  ...authApi,
  ...reportsApi,
  ...adminApi,
  ...complianceApi,
  ...noticesApi,
  attendance: attendanceApi,
  overtime: overtimeApi,
  onboarding: onboardingChecklistApi,
  leaveRequests: leaveRequestsApi,
};
